module.exports = __webpack_public_path__ + "img/K-coin.8d1ab12.png";